import { Col, Container, Row, Tab, Tabs } from "react-bootstrap";
import TabModelo from "./TabModelo";

//XL
import xl_blanco from "../../assets/img/ranger/modelos/XL/4X2/xl-4x2-blanca.png";
import xl_gris from "../../assets/img/ranger/modelos/XL/4X2/xl-4x2-gris.png";

//XL y XLS
import xls_blanco from "../../assets/img/ranger/modelos/XLS/4wd/xls-4wd-blanca.png";
import xls_naranjaterra from "../../assets/img/ranger/modelos/XLS/4wd/xls-4wb-naranjaterra.png";
import xls_azul from "../../assets/img/ranger/modelos/XLS/4wd/xls-4wd-azul.png";
import xls_gris from "../../assets/img/ranger/modelos/XLS/4wd/xls-4wd-gris.png";
import xls_grismagnetic from "../../assets/img/ranger/modelos/XLS/4wd/xls-4wd-grismagnetic.png";
import xls_negro from "../../assets/img/ranger/modelos/XLS/4wd/xls-4wd-negro.png";
import xls_rojo from "../../assets/img/ranger/modelos/XLS/4wd/xls-4wd-rojobari.png";

//XLT
import xlt_blanco from "../../assets/img/ranger/modelos/XLT/4x4/xlt-4x4-blanco.png";
import xlt_naranjaterra from "../../assets/img/ranger/modelos/XLT/4x4/xlt-4x4-naranjaterra.png";
import xlt_azul from "../../assets/img/ranger/modelos/XLT/4x4/xlt-4x4-azul.png";
import xlt_gris from "../../assets/img/ranger/modelos/XLT/4x4/xlt-4x4-gris.png";
import xlt_grismagnetic from "../../assets/img/ranger/modelos/XLT/4x4/xlt-4x4-grismagnetic.png";
import xlt_negro from "../../assets/img/ranger/modelos/XLT/4x4/xlt-4x4-negro.png";
import xlt_rojo from "../../assets/img/ranger/modelos/XLT/4x4/xlt-4x4-rojobari.png";

//LTD y LTD+
import ltd_azul from "../../assets/img/ranger/modelos/LTD/ltd-azul.png";
import ltd_azul_2 from "../../assets/img/ranger/modelos/LTD/ltd-azul-1.png";
import ltd_blanco from "../../assets/img/ranger/modelos/LTD/ltd-blanco.png";
import ltd_gris from "../../assets/img/ranger/modelos/LTD/ltd-gris.png";
import ltd_grismagnetic from "../../assets/img/ranger/modelos/LTD/ltd-grismagnetic.png";
import ltd_naranjaterra from "../../assets/img/ranger/modelos/LTD/ltd-naranjaterra.png";
import ltd_rojo from "../../assets/img/ranger/modelos/LTD/ltd-rojo.png";

//LTD+
import ltdplus_azul from "../../assets/img/ranger/modelos/LTD+/ltd+-azul.png";
import ltdplus_negro from "../../assets/img/ranger/modelos/LTD+/ltd+-negro.png";
import ltdplus_blanco from "../../assets/img/ranger/modelos/LTD+/ltd+-blanco.png";
import ltdplus_gris from "../../assets/img/ranger/modelos/LTD+/ltd+-gris.png";
import ltdplus_grismagnetic from "../../assets/img/ranger/modelos/LTD+/ltd+-grismagnetic.png";
import ltdplus_naranjaterra from "../../assets/img/ranger/modelos/LTD+/ltd+-naranjaterra.png";
import ltdplus_rojo from "../../assets/img/ranger/modelos/LTD+/ltd+-rojo.png";

//BLACK

import black_black from "../../assets/img/ranger/modelos/black/black.png";
import black_gris from "../../assets/img/ranger/modelos/black/gris.png";

import { useEffect, useState } from "react";

export const colores = {
  rojo: "#D51C2D",
  azul: "#295DB9",
  grisoscuro: "#3B3F42",
  gris: "#b4b4b4",
  grismagnetic: "#6F7173",
  naranja: "#AE4D15",
  blanco: "#FFF",
  negro: "#000",
};

const Modelos = () => {
  const models = [
    {
      modelo: "XL",
      id: "XL",
      fondoAzul: "Disponible en 4x2 y 4x4",
      types: [
        {
          title: "XL 2.0L Diesel Cabina Doble 4x2",
          transmision: "4X2",
          specs: [
            "Transmisión manual",
            "Motor 2.0L Turbo diesel con 170 CV 405 Nm de torque",
            "7 Airbags",
            "Pantalla multitáctil de 10''",
          ],
          colores: [
            { file: xl_blanco, color: colores.blanco },
            { file: xl_gris, color: colores.gris },
          ],
        },
        {
          title: "XL 2.0L Diesel Cabina Doble 4x4",
          transmision: "4X4",
          specs: [
            "Transmisión manual",
            "Motor 2.0L Turbo diesel con 170 CV 405 Nm de torque",
            "7 Airbags",
            "Pantalla multitáctil de 10''",
          ],
          colores: [
            { file: xl_blanco, color: colores.blanco },
            { file: xl_gris, color: colores.gris },
          ],
        },
      ],
      ficha: "https://montironiford.com/wp-content/uploads/2024/02/far-nueva-ranger-ficha-tecnica.pdf",
    },
    {
      modelo: "XLS",
      id: "XLS",
      fondoAzul: "Disponible en 4x2 y 4x4",
      types: [
        {
          title: "XLS 2.0L Diesel Cabina Doble 4x2",
          transmision: "4X2",
          specs: [
            "Transmisión manual",
            "Motor 2.0L Turbo diesel con 170 CV 405 Nm de torque",
            "Llantas de aleación de 17''",
            "Cámara y sensores traseros de estacionamiento",
          ],
          colores: [
            { file: xls_blanco, color: colores.blanco },
            { file: xls_gris, color: colores.gris },
            { file: xls_grismagnetic, color: colores.grismagnetic },
            { file: xls_azul, color: colores.azul },
            { file: xls_rojo, color: colores.rojo },
          ],
        },
        {
          title: "XLS 2.0L Diesel Cabina Doble 4WD",
          transmision: "4WD",
          specs: [
            "Transmisión manual",
            "Motor 3.0L V6 Turbo diesel con 250 CV 600 Nm de torque",
            "Freno a disco en las 4 ruedas",
            "Caja automática de 10 velocidades y sistema de gestión de terrenos",
          ],
          colores: [
            { file: xls_blanco, color: colores.blanco },
            { file: xls_gris, color: colores.gris },
            { file: xls_grismagnetic, color: colores.grismagnetic },
            { file: xls_azul, color: colores.azul },
            { file: xls_rojo, color: colores.rojo },
            { file: xls_negro, color: colores.grisoscuro },
            { file: xls_naranjaterra, color: colores.naranja },
          ],
        },
      ],
      ficha: "https://montironiford.com/wp-content/uploads/2024/02/far-nueva-ranger-ficha-tecnica.pdf",
    },
    {
      modelo: "XLT",
      id: "XLT",
      fondoAzul: "Disponible en 4x2 y 4x4",
      types: [
        {
          title: "XLT 2.0L Diesel Cabina Doble 4x2",
          transmision: "4X2",
          specs: [
            "Transmisión Automática",
            "Motor 2.0L Bi-Turbo diesel con 210 CV 500 Nm de torque",
            "Asiento de cuero ecológico",
            "Cámara y sensores traseros de estacionamiento",
          ],
          colores: [
            { file: xlt_blanco, color: colores.blanco },
            { file: xlt_gris, color: colores.gris },
            { file: xlt_grismagnetic, color: colores.grismagnetic },
            { file: xlt_azul, color: colores.azul },
            { file: xlt_rojo, color: colores.rojo },
            { file: xlt_negro, color: colores.grisoscuro },
            { file: xlt_naranjaterra, color: colores.naranja },
          ],
        },
        {
          title: "XLT 2.0L Diesel Cabina Doble 4x4",
          transmision: "4WD",
          specs: [
            "Transmisión Automática",
            "Motor 2.0L Bi-Turbo diesel con 210 CV 500 Nm de torque",
            "Asiento de cuero ecológico",
            "Cámara y sensores traseros de estacionamiento",
          ],
          colores: [
            { file: xlt_blanco, color: colores.blanco },
            { file: xlt_gris, color: colores.gris },
            { file: xlt_grismagnetic, color: colores.grismagnetic },
            { file: xlt_azul, color: colores.azul },
            { file: xlt_rojo, color: colores.rojo },
            { file: xlt_negro, color: colores.grisoscuro },
            { file: xlt_naranjaterra, color: colores.naranja },
          ],
        },
      ],
      ficha: "https://montironiford.com/wp-content/uploads/2024/02/far-nueva-ranger-ficha-tecnica.pdf",
    },
    {
      modelo: "LTD",
      id: "ltd",
      fondoAzul: "Disponible en 4x4",
      types: [
        {
          title: "LTD 2.0L Diesel Cabina Doble 4x4",
          transmision: "4X4",
          specs: [
            "Transmisión automática",
            "Motor 2.0L Bi-Turbo diesel con 210 CV 500 Nm de torque",
            "Sistema de gestión de terrenos",
            "Sistema de mantenimiento de carril",
          ],
          colores: [
            { file: ltd_azul, color: colores.azul },
            { file: ltd_azul_2, color: colores.grisoscuro },
            { file: ltd_blanco, color: colores.blanco },
            { file: ltd_gris, color: colores.gris },
            { file: ltd_grismagnetic, color: colores.grismagnetic },
            { file: ltd_naranjaterra, color: colores.naranja },
            { file: ltd_rojo, color: colores.rojo },
          ],
        },
      ],
      ficha: "https://montironiford.com/wp-content/uploads/2024/02/far-nueva-ranger-ficha-tecnica.pdf",
    },
    {
      modelo: "LTD+",
      id: "ltd+",
      types: [
        {
          title: "LTD+ 3.0L V6 Diesel Cabina Doble 4WD",
          transmision: "4WD",
          specs: [
            "Transmisión automática",
            "Motor 3.0L V6 Turbo diesel con 250 CV 600 Nm de torque",
            "Sistema de gestión de terrenos",
            "Sistema de mantenimiento de carril",
          ],
          colores: [
            { file: ltdplus_azul, color: colores.azul },
            { file: ltdplus_negro, color: colores.grisoscuro },
            { file: ltdplus_blanco, color: colores.blanco },
            { file: ltdplus_gris, color: colores.gris },
            { file: ltdplus_grismagnetic, color: colores.grismagnetic },
            { file: ltdplus_naranjaterra, color: colores.naranja },
            { file: ltdplus_rojo, color: colores.rojo },
          ],
        },
      ],
      ficha: "https://montironiford.com/wp-content/uploads/2024/02/far-nueva-ranger-ficha-tecnica.pdf",
    },
    {
      modelo: "Black",
      id: "black",
      fondoAzul: "Disponible en 4x4",
      types: [
        {
          title: "Black 2.0L Diesel Cabina Doble",
          transmision: "4WD",
          specs: [
            "Transmisión automática",
            "Motor 2.0L Turbo diesel con 170 CV 405 Nm de torque",
            "Llantas de aleación 18''",
            "Cámara y sensores traseros de estacionamiento",
          ],
          colores: [
            { file: black_black, color: colores.negro },
            { file: black_gris, color: colores.gris },
          ],
        },
      ],
      ficha: "https://montironiford.com/wp-content/uploads/2024/02/far-nueva-ranger-ficha-tecnica.pdf",
    },
  ];

  const [selectedModel, setSelectedModel] = useState("XL");
  const [selectedTransmision, setSelectedTransmision] = useState();
  const [selectedItem, setSelectedItem] = useState();
  const [selectedColor, setSelectedColor] = useState();

  useEffect(() => {
    setSelectedItem(models.find((t) => t.modelo === selectedModel));
  }, [selectedModel]);

  useEffect(() => {
    setSelectedTransmision(selectedItem?.types[0]?.transmision);
    setSelectedColor(selectedItem?.types[0]?.colores[0]);
  }, [selectedItem]);

  return (
    <Container className="pt-5" id="versiones">
      <Row>
        {
          //MOBILE
        }
        <Col className="d-md-none d-block">
          <Row>
            {models.map((item) => (
              <Col className="p-1 text-center">
                <button
                  className={`tabModelo ${selectedModel === item.modelo ? "active" : ""} p-0`}
                  onClick={() => setSelectedModel(item.modelo)}
                >
                  {item.modelo}
                </button>
              </Col>
            ))}
          </Row>

          {models
            .filter((t) => t.modelo === selectedModel)
            .map((item) => (
              <TabModelo
                item={item}
                selectedItem={selectedItem}
                selectedColor={selectedColor}
                selectedTransmision={selectedTransmision}
                setSelectedColor={setSelectedColor}
                setSelectedTransmision={setSelectedTransmision}
              />
            ))}
        </Col>
        {
          //DESKTOP
        }
        <Col className="d-md-block d-none" id="modelos">
          <Row>
            <Row className="no-gutters">
              <Col md={6} xs={11} className="mx-auto">
                <Row>
                  <Col className="pb-5">
                    <h1 className="title_elegi">Elegí tu versión de Ranger</h1>
                  </Col>
                </Row>
                <Row>
                  {models.map((item) => (
                    <Col>
                      <button
                        className={`tabModelo ${selectedModel === item.modelo ? "active" : ""}`}
                        onClick={() => setSelectedModel(item.modelo)}
                      >
                        {item.modelo}
                      </button>
                    </Col>
                  ))}
                </Row>
              </Col>
            </Row>

            {models
              .filter((t) => t.modelo === selectedModel)
              .map((item) => (
                <TabModelo
                  item={item}
                  selectedItem={selectedItem}
                  selectedColor={selectedColor}
                  selectedTransmision={selectedTransmision}
                  setSelectedColor={setSelectedColor}
                  setSelectedTransmision={setSelectedTransmision}
                />
              ))}
          </Row>
        </Col>
      </Row>
      <div id="form"></div>
    </Container>
  );
};

export default Modelos;
